import { render, staticRenderFns } from "./sale-order-relation-order.vue?vue&type=template&id=25ba8981&scoped=true&"
import script from "./sale-order-relation-order.vue?vue&type=script&lang=js&"
export * from "./sale-order-relation-order.vue?vue&type=script&lang=js&"
import style0 from "./sale-order-relation-order.vue?vue&type=style&index=0&id=25ba8981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ba8981",
  null
  
)

export default component.exports